/**
 * Interactive Learning components - modular exports
 */

export { DocumentsButton } from './DocumentsButton';
export { DocumentsPanel } from './DocumentsPanel';
export { DocumentCard } from './DocumentCard';
export { DocumentPdfModal } from './DocumentPdfModal';
export { PlayGameTab } from './PlayGameTab';
export { MoreInfoTab } from './MoreInfoTab';
export { DocumentationTab } from './DocumentationTab';
export { InteractiveLearningIntro } from './InteractiveLearningIntro';
export { StructuredContentBlock } from './StructuredContentBlock';

export { useDocumentsPanel } from './hooks/useDocumentsPanel';
export { useFullscreen } from './hooks/useFullscreen';
export {
  buildIframeQueryString,
  collectDocumentsFromGameCards,
  collectVideoSources,
} from './hooks/useInteractiveLearningData';

export {
  DOCUMENTS_PANEL,
  DOCUMENT_ICON_PATH,
  POST_MESSAGE_TYPES,
} from './constants';
